import type { SVGProps } from 'react';
const DawnFlagAZ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-AZ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AZ_svg__a)">
      <path fill="#24AAD5" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path fill="#21BF75" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      <path
        fill="#ED1845"
        fillRule="evenodd"
        d="M0 10.667h22V5.333H0z"
        clipRule="evenodd"
      />
      <g filter="url(#dawn-flag-AZ_svg__b)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M11 9.6c.323 0 .624-.1.873-.27l-.087.003c-.723 0-1.31-.597-1.31-1.333a1.32 1.32 0 0 1 1.397-1.33c-.25-.17-.55-.27-.873-.27-.868 0-1.571.716-1.571 1.6S10.132 9.6 11 9.6M12.572 8a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.533.524-.533s.524.238.524.533"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <filter
        id="dawn-flag-AZ_svg__b"
        width={3.143}
        height={4.2}
        x={9.429}
        y={6.4}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_195" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_195" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagAZ;
